import React from "react";

function Tag({ theme, text }) {
  const lightTags = [
    'teal',
    'cream-2',
    'cream-3',
    'yellow',
    'yellow-3',
    'yellow-4',
    'pink',
    'purple-4'
  ];
  // Special case for cream-3.
  if (theme === 'cream') {
    theme = 'cream-3';
  }
  const tagTheme = () => {
    if (lightTags.includes(theme)) {
      return 'light-' + theme;
    }
    return 'dark-' + theme;
  };
  return (<span className={`tag tag--type surface--${tagTheme()}`}> { text } </span>);
}

export default Tag;
